import { render, staticRenderFns } from "./DetallesPedido.vue?vue&type=template&id=7183135a&scoped=true&"
import script from "./DetallesPedido.vue?vue&type=script&lang=js&"
export * from "./DetallesPedido.vue?vue&type=script&lang=js&"
import style0 from "./DetallesPedido.vue?vue&type=style&index=0&id=7183135a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183135a",
  null
  
)

export default component.exports